import { useEffect, useState } from 'react';
import { minBy } from 'lodash';
import useTracking from 'hooks/useTracking';
import useFetch from 'hooks/useFetch';
import { getCollectionsPlansPricing } from 'data/api';
import { transformCollectionsPlansPricingResponse } from 'data/api/transformers/response';
import { clickEvent } from 'libs/common/event-tracker/events';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { Screen } from 'constants/tracking/screens';
import MultipleCollectionsPlansModal from '../MultipleCollectionsPlansModal';
import MultipleCollectionsOnboardingModal from '../MultipleCollectionsOnboardingModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CollectionsModal;

(function (CollectionsModal) {
  CollectionsModal["Onboarding"] = "onboarding";
  CollectionsModal["Plans"] = "plans";
})(CollectionsModal || (CollectionsModal = {}));

const MultipleCollectionsOnboarding = _ref => {
  let {
    isOnboardingOpen,
    onClose
  } = _ref;
  const {
    track
  } = useTracking();
  const {
    0: activeModal,
    1: setActiveModal
  } = useState();
  const {
    fetch: fetchPlansPricing,
    isLoading,
    transformedData: plansPricing,
    error
  } = useFetch(getCollectionsPlansPricing, transformCollectionsPlansPricingResponse);
  const isFetchPlansPricingInitiated = !!plansPricing || isLoading || error;
  const cheapestPlan = minBy(plansPricing, plan => parseFloat(plan.totalPrice.amount));
  const maxActiveCollectionsCount = plansPricing ? Math.max(...plansPricing.map(plan => plan.maxActiveCount)) : 0;
  useEffect(() => {
    if (!isOnboardingOpen) return;
    setActiveModal(CollectionsModal.Onboarding);
  }, [isOnboardingOpen]);
  useEffect(() => {
    if (!isOnboardingOpen || isFetchPlansPricingInitiated) return;
    fetchPlansPricing();
  }, [fetchPlansPricing, isOnboardingOpen, isFetchPlansPricingInitiated]);

  function handlePriceInfoClick() {
    setActiveModal(CollectionsModal.Plans);
    track(clickEvent({
      screen: Screen.FeaturedCollection,
      target: ClickableElement.PriceInformation
    }));
  }

  function handlePlansModalBackClick() {
    setActiveModal(CollectionsModal.Onboarding);
  }

  function handleOnboardingClose() {
    setActiveModal(undefined);
    onClose();
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MultipleCollectionsOnboardingModal, {
      isShown: activeModal === CollectionsModal.Onboarding,
      isLoading: isLoading,
      cheapestPlan: cheapestPlan,
      maxActiveCollectionsCount: maxActiveCollectionsCount,
      onClose: handleOnboardingClose,
      onPriceInfoClick: handlePriceInfoClick
    }), plansPricing && /*#__PURE__*/_jsx(MultipleCollectionsPlansModal, {
      isShown: activeModal === CollectionsModal.Plans,
      plansPricing: plansPricing,
      onBack: handlePlansModalBackClick
    })]
  });
};

export default MultipleCollectionsOnboarding;